import React, { useState } from "react";
import ButtonComponent from "../../../components/common/button/Button";
import Modal from "../../../components/common/modal/Modal";
import "../../LT/analyticsresults/ViewAllDetails.css";
import { Grid, TextareaAutosize, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { postCreateTicketOutbound } from "../../../redux/actions/CreateTicketOutbountSlice";
import { createTicketOutboundEndpoint } from "../../../common/endpoints";
import { toast } from "react-toastify";

const CreateTicketModal = ({ openCreateTicket, data, handleCloseCreateTicket, loading }) => {

    const dispatch = useDispatch();
    const [remarks, setRemarks] = useState("");
    const [apiResponse, setApiResponse] = useState("");
    const userEmail = localStorage.getItem("data");
    const stateSelector = useSelector((state) => state);

    const handleTextAreaChange = (e) => {
        setRemarks(e.target.value)
    }
    const handleClose = (e) => {
        setRemarks("");
        setApiResponse("");
        handleCloseCreateTicket();
    }

    const handleCreateTicketAPI = async () => {
        const arr = [];
        data.map((item) => arr.push(item.outboundIntSeqId))
        const createTicketRequestBody = {
            "userEmail": userEmail,
            "outboundIntSeqIds": arr,
            "userRemarks": remarks
        }
        try {
            const responseResolved = await dispatch(postCreateTicketOutbound({
                dynamicEndpoint: `${createTicketOutboundEndpoint}`,
                data: createTicketRequestBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                },
            }));
            if (responseResolved?.meta?.requestStatus === 'fulfilled') {
                setApiResponse(responseResolved?.payload)
            } else {
                toast.error(responseResolved?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    return (
        <div>
            <Modal
                className="LeadTimeModal_cls"
                open={openCreateTicket}
                handleClose={handleClose}
                title="Create Ticket"
                action={
                    <CreateTicketFooter
                        className="viewAllDetails_cls"
                        handleCloseModal={handleClose}
                        handleCreateTicketAPI={handleCreateTicketAPI}
                        apiResponse={apiResponse}
                        remarks={remarks}
                    />
                }
                content={
                    <CreateTicketContent data={data} loading={loading} stateSelector={stateSelector} apiResponse={apiResponse} handleTextAreaChange={handleTextAreaChange} />
                }
            />
        </div>
    )
}
export default CreateTicketModal;

const CreateTicketFooter = ({ handleCloseModal, apiResponse, handleCreateTicketAPI }) => {

    return (
        <div className='button-alignment'>
            {apiResponse ?
                <ButtonComponent
                    maxWidth="170px"
                    label="Close"
                    type="secondary"
                    onClick={handleCloseModal}
                /> :
                <ButtonComponent
                    maxWidth="170px"
                    label="Submit"
                    type="secondary"
                    onClick={handleCreateTicketAPI}
                />}
        </div>
    )
}

const CreateTicketContent = ({ handleTextAreaChange, apiResponse, stateSelector }) => {

    return (
        stateSelector?.CreateTicketOutbountSlice?.loading ?
            <div style={{ width: 500, height: 210, display: 'flex', justifyContent: 'center', alignItems: 'center' }}> <CircularProgress color="inherit" /></div>
            :
            <div style={{ width: 500 }}>
                {apiResponse ?
                    <div>
                        <div style={{ display: 'flex' }}>
                            <p style={{ flex: 2 }}>Line Items with Successfully Submitted Ticket Requests </p>
                            <p style={{ flex: 1 }}> : <b>{apiResponse?.successfulSubmitCount}</b></p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p style={{ flex: 2 }}>Line Items with Existing Tickets </p>
                            <p style={{ flex: 1 }}> : <b>{apiResponse?.alreadyCreatedCount}</b></p>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <p style={{ flex: 2 }}>Line Items Where Ticket Creation Is Not Allowed </p>
                            <p style={{ flex: 1 }}> : <b>{apiResponse?.notAllowedCount}</b></p>
                        </div>
                    </div> :
                    <div>
                        <p>Enter Remarks (Optional):</p>
                        <div>
                            <TextareaAutosize
                                minRows={10}
                                style={{ width: "100%", fontSize: 16 }}
                                onChange={handleTextAreaChange}
                            />
                        </div>
                    </div>}
            </div>
    )
}